export default __webpack_public_path__ + "static/media/bg12.f75b6b87.jpg";